import React from 'react';
import { BuyCreditsModal as SharedBuyCreditsModal, createCreditCheckoutViaSupabase } from '@rehub/buy-credits';
import { supabase, isConfigured } from '../services/supabase';
import type { UserProfile } from '../types';

interface CreditsModalProps {
  user: UserProfile;
  onClose: () => void;
}

const CreditsModal: React.FC<CreditsModalProps> = ({ user, onClose }) => (
  <SharedBuyCreditsModal
    userId={user.id}
    credits={user.credits ?? 0}
    onClose={onClose}
    appSource="floorplan"
    accent="orange"
    createCheckout={async (params) => {
      if (!isConfigured) throw new Error('Payment system not available.');
      return createCreditCheckoutViaSupabase(supabase, params);
    }}
  />
);

export default CreditsModal;
